import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2764c247")

_pushScopeId("data-v-2764c247")
const _hoisted_1 = { class: "p-d-flex p-flex-column p-flex-md-row" }
const _hoisted_2 = { class: "p-field p-mb-2 p-mr-2" }
const _hoisted_3 = { class: "p-field p-mb-2 p-mr-2" }
const _hoisted_4 = { class: "p-field p-mb-2 p-mr-2" }
const _hoisted_5 = { class: "p-d-flex p-flex-column p-flex-md-row" }
const _hoisted_6 = { class: "p-field p-mb-2 p-mr-2 p-col-12" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode()
const _hoisted_8 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode()
const _hoisted_11 = /*#__PURE__*/_createVNode("a", {
  href: "https://swisslichens.wsl.ch/en/index.html",
  target: "_blank"
}, " SwissLichens ", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Message = _resolveComponent("Message")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_InputText, {
          type: "text",
          modelValue: _ctx.email,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.email = $event)),
          class: ["p-inputtext-sm p-mb-2", { 'is-error': _ctx.error }],
          placeholder: "mail@example.ch"
        }, null, 8, ["modelValue", "class"])
      ]),
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_Button, {
          label: _ctx.$t('form.search_person'),
          icon: "pi pi-search",
          iconPos: "right",
          disabled: !_ctx.validEmail(),
          class: ["p-button-raised p-button-primary p-button-sm", { customDisabled: !_ctx.validEmail() }],
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.search(_ctx.email)))
        }, null, 8, ["label", "disabled", "class"])
      ]),
      _createVNode("div", _hoisted_4, [
        (_ctx.addedPersons.length > 0)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              label: _ctx.$t('form.delete_person_list'),
              class: "p-button-raised p-button-danger p-button-sm",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.clearPersonList()))
            }, null, 8, ["label"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode("div", _hoisted_6, [
        (_ctx.personFound==='yes' || _ctx.addedPersons.flat().length > 0)
          ? (_openBlock(), _createBlock(_component_Message, {
              key: 0,
              severity: "success",
              closable: false
            }, {
              default: _withId(() => [
                _createVNode("b", null, _toDisplayString(_ctx.$t('form.added_person')), 1),
                _hoisted_7,
                _hoisted_8,
                _createTextVNode(_toDisplayString(_ctx.addedPersons.join(' ; ')), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.personFound==='noSelection' || _ctx.persons.flat().length === 0)
          ? (_openBlock(), _createBlock(_component_Message, {
              key: 1,
              severity: "info",
              closable: false
            }, {
              default: _withId(() => [
                _createVNode("b", null, _toDisplayString(_ctx.$t('form.noselection_person')), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.personFound==='no')
          ? (_openBlock(), _createBlock(_component_Message, {
              key: 2,
              severity: "warn",
              closable: true
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('form.not_in_database')) + "   " + _toDisplayString(_ctx.email) + " ", 1),
                _hoisted_9,
                _hoisted_10,
                _hoisted_11
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
})